export enum Language {
  ENGLISH = 'en',
  POLISH = 'pl',
}
